"use client";

import Footer from "@/components/footer";
import { setGlobalTheme } from "@/utils";
import OnlyClient from "@/utils/OnlyClient";
import { ThemeProvider, useTheme } from "@/utils/ThemeContext";
import { useEffect } from "react";

const ThemeWrapper = ({ children }: { children: React.ReactNode }) => {
  const { theme } = useTheme();

  useEffect(() => {
    setGlobalTheme(theme);
  }, [theme]);

  return <>{children}</>;
};

export default function Template({ children }: { children: React.ReactNode }) {
  // The platform is being phased out. All authentication, wallet, and
  // deployment functionality has been removed; the app now serves a single
  // static phase-out notice. Only the theme wrapper and branded footer remain.
  return (
    <ThemeProvider>
      <ThemeWrapper>
        <div className="min-h-screen flex flex-col">
          <div className="flex-1">{children}</div>
          <footer className="mt-[100px]">
            <OnlyClient>
              <Footer />
            </OnlyClient>
          </footer>
        </div>
      </ThemeWrapper>
    </ThemeProvider>
  );
}
